export type LookupItem = { id: string; name: string; code?: string };

export type SubFileCategory = {
  id: string;
  name: string;
  applicableAreas: string[];
};

export const FILE_CATEGORY_CRIMINAL = 'Criminal Division';

export const SUB_FILE_CATEGORIES: SubFileCategory[] = [
  {
    id: 'human-body',
    name: 'Offence Affecting Human Body/ Life',
    applicableAreas: [
      'Murder',
      'Attempted Murder',
      'Causing Death by Negligence',
      'Hurt',
      'Kidnapping',
      'Abduction',
      'Procuration',
      'Rape',
      'Grave Sexual Abuse',
      'Sexual Harassment',
      'Criminal intimidation',
      'Other',
    ],
  },
  {
    id: 'property',
    name: 'Offence against Property',
    applicableAreas: [
      'Theft',
      'Extortion',
      'Robbery',
      'Retention of Stolen Property',
      'Dishonest Misappropriation of Property',
      'Mischief',
      'Trespass',
      'House Breaking',
      'Other',
    ],
  },
  {
    id: 'documents',
    name: 'Offences relating to Documents Property Marks, Currency Notes and Bank Notes',
    applicableAreas: [
      'Forgery',
      'Falsification of Accounts',
      'Counterfeit Currency - Creating Counterfeit Notes',
      'Counterfeit Currency - Using Counterfeit Currency',
      'Offences related to Credit Cards & Computer Crimes',
      'Criminal Breach of Trust',
      'Cheating',
      'Other',
    ],
  },
  {
    id: 'child-abuse',
    name: 'CH - Child Abuse',
    applicableAreas: [
      'Statutory Rape',
      'Grave Sexual Abuse',
      'Sexual Harassment',
      'Incest',
      'Abduction',
      'Kidnapping',
      'Procuration',
      'Cruelty to Children',
      'Other',
    ],
  },
  { id: 'immigration', name: 'I &E – Immigration and Emigration', applicableAreas: ['Offences under Immigrants and Emigrants Act', 'Procuration'] },
  { id: 'eer', name: 'EER - Emergency Regulations', applicableAreas: ['Offences under Emergency Regulations'] },
  { id: 'pta', name: 'PTA - Prevention of Terrorism Act', applicableAreas: ['Offences under Prevention of Terrorism Act'] },
  {
    id: 'aml',
    name: 'AML/CFT - Anti-Money Laundering and Counter Financing of Terrorism',
    applicableAreas: ['Money Laundering', 'Terrorist financing', 'Other'],
  },
  {
    id: 'drugs',
    name: 'CR3 - Drugs related offences',
    applicableAreas: ['Possession', 'Trafficking', 'Importation', 'Manufacturing'],
  },
  { id: 'election', name: 'CR7- Offences under the Election Law', applicableAreas: [] },
  { id: 'weapons', name: 'OW - Offensive Weapons', applicableAreas: ['Offensive Weapons', 'Exposives', 'Firearms'] },
  { id: 'wildlife', name: 'WL- Offences against WildLife', applicableAreas: [] },
  { id: 'cyber', name: 'Offences related to Credit Cards & Computer Crimes', applicableAreas: [] },
  { id: 'misc', name: 'Miscellaneous', applicableAreas: [] },
  { id: 'bribery', name: 'Bribery & Corruption', applicableAreas: [] },
  { id: 'sports', name: 'Sports Related Offences', applicableAreas: [] },
  { id: 'other', name: 'Other Offences', applicableAreas: [] },
  { id: 'public-property', name: 'Offences under Public Property Act', applicableAreas: [] },
];

export const CASE_SOURCES = [
  'Magistrate Court (MC)',
  'Director Legal-Police',
  'Police Narcotic Bureau (PNB)',
  'National Child Protection Authority (NCPA)',
  'Terrorist Investigation Division (TID)',
  'Anti-Money Laundering & Counter Terrorist Financing (AML/CTF)',
  'FCID',
  'Colombo Fraud Investigation Bureau (CFIB)',
  'Special Presidential Commission of Inquiry',
  'Commission to Investigate Allegations of Bribery or Corruption (CIABOC)',
  'Other',
] as const;

export const PROVINCES: LookupItem[] = [
  { id: 'western', name: 'Western' },
  { id: 'central', name: 'Central' },
  { id: 'southern', name: 'Southern' },
  { id: 'northern', name: 'Northern' },
  { id: 'eastern', name: 'Eastern' },
  { id: 'north-western', name: 'North Western' },
  { id: 'north-central', name: 'North Central' },
  { id: 'uva', name: 'Uva' },
  { id: 'sabaragamuwa', name: 'Sabaragamuwa' },
];

export const DISTRICTS_BY_PROVINCE: Record<string, LookupItem[]> = {
  western: [
    { id: 'colombo', name: 'Colombo' },
    { id: 'gampaha', name: 'Gampaha' },
    { id: 'kalutara', name: 'Kalutara' },
  ],
  central: [
    { id: 'kandy', name: 'Kandy' },
    { id: 'matale', name: 'Matale' },
    { id: 'nuwara-eliya', name: 'Nuwara-Eliya' },
  ],
  southern: [
    { id: 'galle', name: 'Galle' },
    { id: 'matara', name: 'Matara' },
    { id: 'hambantota', name: 'Hambantota' },
  ],
  northern: [
    { id: 'jaffna', name: 'Jaffna' },
    { id: 'kilinochchi', name: 'Kilinochchi' },
    { id: 'mannar', name: 'Mannar' },
    { id: 'vavuniya', name: 'Vavuniya' },
  ],
  eastern: [
    { id: 'trincomalee', name: 'Trincomalee' },
    { id: 'batticaloa', name: 'Batticaloa' },
    { id: 'ampara', name: 'Ampara' },
  ],
  'north-western': [
    { id: 'kurunegala', name: 'Kurunegala' },
    { id: 'puttalam', name: 'Puttalam' },
  ],
  'north-central': [
    { id: 'anuradhapura', name: 'Anuradhapura' },
    { id: 'polonnaruwa', name: 'Polonnaruwa' },
  ],
  uva: [
    { id: 'badulla', name: 'Badulla' },
    { id: 'monaragala', name: 'Monaragala' },
  ],
  sabaragamuwa: [
    { id: 'ratnapura', name: 'Ratnapura' },
    { id: 'kegalle', name: 'Kegalle' },
  ],
};

export const COURTS: LookupItem[] = [
  { id: 'colombo-mc', name: 'Colombo Magistrate Court' },
  { id: 'kandy-mc', name: 'Kandy Magistrate Court' },
  { id: 'galle-mc', name: 'Galle Magistrate Court' },
  { id: 'negombo-mc', name: 'Negombo Magistrate Court' },
  { id: 'jaffna-mc', name: 'Jaffna Magistrate Court' },
];

export const HIGH_COURTS: LookupItem[] = [
  { id: 'colombo-hc', name: 'Colombo High Court' },
  { id: 'kandy-hc', name: 'Kandy High Court' },
  { id: 'galle-hc', name: 'Galle High Court' },
  { id: 'jaffna-hc', name: 'Jaffna High Court' },
];

export const POLICE_STATIONS: LookupItem[] = [
  { id: 'colombo-fort', name: 'Colombo Fort' },
  { id: 'maligakanda', name: 'Maligakanda' },
  { id: 'kandy', name: 'Kandy' },
  { id: 'galle', name: 'Galle' },
  { id: 'negombo', name: 'Negombo' },
];

export const URGENCY_LEVELS: LookupItem[] = [
  { id: 'high', name: 'High' },
  { id: 'medium', name: 'Medium' },
  { id: 'low', name: 'Low' },
];

export const SUSPECT_STATUSES: LookupItem[] = [
  { id: 'remand', name: 'Remand' },
  { id: 'bail', name: 'On bail' },
  { id: 'not-arrested', name: 'Not arrested' },
  { id: 'other', name: 'Other' },
];

/** CMS-MCC-1 — fallback when current-custody-statuses API is unavailable */
export const CURRENT_CUSTODY_STATUSES: LookupItem[] = [
  { id: 'IN_SL_CUSTODY', name: 'In SL Custody', code: 'IN_SL_CUSTODY' },
  { id: 'IN_FOREIGN_CUSTODY', name: 'In Foreign Custody', code: 'IN_FOREIGN_CUSTODY' },
  { id: 'ABSCONDING', name: 'Absconding', code: 'ABSCONDING' },
  { id: 'UNKNOWN', name: 'Unknown', code: 'UNKNOWN' },
];

export const DELIVERY_METHODS = [
  'In Person',
  'Registered Post',
  'Courier',
  'Fax',
  'Parcel Document',
  'Other',
] as const;

export type DocumentChecklistItem = {
  /** Checklist row id from CMS-MCRCD-1 */
  id: string;
  documentTypeId: string;
  name: string;
  documentTypeCode?: string;
  mandatory: boolean;
};

/** Fallback checklist when CMS-MCRCD-1 is unavailable (file category level). */
export function getDocumentChecklistForFileCategory(_fileCategoryId?: string): DocumentChecklistItem[] {
  return [
    { id: 'b-report', documentTypeId: 'b-report', name: 'B Report', mandatory: true },
    { id: 'ib-extracts', documentTypeId: 'ib-extracts', name: 'IB Extracts', mandatory: true },
    { id: 'gov-analyst', documentTypeId: 'gov-analyst', name: 'Government Analyst Report', mandatory: false },
    { id: 'mlr', documentTypeId: 'mlr', name: 'MLR', mandatory: false },
    { id: 'pmr', documentTypeId: 'pmr', name: 'PMR', mandatory: false },
  ];
}

export function getDocumentChecklistForSubCategory(subFileCategoryId: string, applicableArea?: string): DocumentChecklistItem[] {
  const base: DocumentChecklistItem[] = [
    { id: 'b-report', documentTypeId: 'b-report', name: 'B report', mandatory: true },
    { id: 'ib-extracts', documentTypeId: 'ib-extracts', name: 'IB extracts', mandatory: true },
    { id: 'pmr', documentTypeId: 'pmr', name: 'PMR- Post-Mortem Report', mandatory: false },
    { id: 'mlr', documentTypeId: 'mlr', name: 'MLR- Medico Legal Report', mandatory: false },
    { id: 'other', documentTypeId: 'other', name: 'Other', mandatory: false },
  ];

  if (subFileCategoryId === 'child-abuse') {
    return [
      { id: 'b-report', documentTypeId: 'b-report', name: 'B report', mandatory: true },
      { id: 'ib-extracts', documentTypeId: 'ib-extracts', name: 'IB extracts', mandatory: true },
      { id: 'birth-cert', documentTypeId: 'birth-cert', name: 'Birth certificate', mandatory: true },
      { id: 'mlr', documentTypeId: 'mlr', name: 'MLR- Medico Legal Report', mandatory: true },
      { id: 'other', documentTypeId: 'other', name: 'Other', mandatory: false },
    ];
  }

  if (subFileCategoryId === 'drugs') {
    return base.map((d) => (d.id === 'other' ? { ...d, mandatory: true } : d));
  }

  if (subFileCategoryId === 'human-body' && (applicableArea === 'Murder' || applicableArea === 'Causing Death by Negligence')) {
    return base.map((d) => (d.id === 'pmr' ? { ...d, mandatory: true } : d));
  }

  if (subFileCategoryId === 'public-property') {
    return [{ id: 'asp-cert', documentTypeId: 'asp-cert', name: 'ASP certificate', mandatory: true }];
  }

  return base;
}
